import React, { useState, useEffect, Fragment } from 'react'
import { useTranslate } from 'react-admin'
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  TablePagination,
  TableFooter,
  Skeleton,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Typography,
} from '@mui/material'
import {
  Visibility,
} from '@mui/icons-material'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import { HasPermission } from 'src/helper/HasPermission'
import {
  PERMISSION_CREATE,
} from 'src/helper/Permission'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { LoadingButton } from '@mui/lab'
import { paymentServices } from 'src/services/payment/Payment.service'
import { getDayWithTimeZone } from '../../../helper/getDay'
import { getAirports } from 'src/components/pages/sales/reservation/logic/air/AirScaleRow'
export const ReserveCreditsApplied = ({originNumber, dataList, dataListLoading, setRefrshReserveCreditsApplied, refreshReserveCreditsApplied }) => {
  const translate = useTranslate()
  const [paginationCreditData, setPaginationCreditData] = useState({ page: 0, rowsPerPage: 10 })
  const [loadingDetail, setLoadingDetail] = useState(false)
  const [openDetailModal, setOpenDetailModal] = useState(false)
  const [detailModalData, setDetailModalData] = useState([])

  const handleOpenDetailModal = (account_detail_id) => {
    setOpenDetailModal(true)
    if (account_detail_id) {
      getExpensesPaidDetailByAccountDetail(account_detail_id)
    }
  }

  const getExpensesPaidDetailByAccountDetail = async (account_detail_id) => {
    try {
      setLoadingDetail(true)
      const response = await paymentServices.getExpensesPaidDetail(account_detail_id)
      setDetailModalData(response)
    } catch (error) {
      setDetailModalData([])
    } finally {
      setLoadingDetail(false)
    }
  }

  const getProductName = (item) => {
    if (item?.product?.ref_table_detail === 'hotel_detail') {
      return item?.name
    } else if (item?.product?.ref_table_detail === 'car_detail') {
      return item?.provider
    } else if (
      item?.product?.ref_table_detail === 'assistance_detail' ||
      item?.product?.ref_table_detail === 'other_detail'
    ) {
      return `${item.destination} / ${item.name}`
    } else if (item?.product?.ref_table_detail === 'transfer_detail') {
      return item?.pickup_origin
    } else if (item?.product?.ref_table_detail === 'air_detail') {
      return getAirports(item?.segments?.[0]?.itineraryGroup)
    } else if (item?.product?.ref_table_detail === 'train_detail_segment') {
      return `${item?.segments?.[0]?.origin_name}/${item?.segments?.[0]?.arrival_name}`
    } else if (item?.product?.ref_table_detail === 'train_detail_passes') {
      return item?.passes?.[0]?.company_name
    }
  }

  const onPageCreditChange = (number) => {
    const paginationCreditDataAux = { ...paginationCreditData }
    paginationCreditDataAux.page = number
    setPaginationCreditData(paginationCreditDataAux)
  }

  const onRowsPerPageCreditChange = (e) => {
    const paginationCreditDataAux = { ...paginationCreditData }
    paginationCreditDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationCreditDataAux.page = 0
    setPaginationCreditData(paginationCreditDataAux)
  }

  return (
    <Grid item xs={12} md={12} lg={12} xl={12}>
      <ShowCard 
        title={translate('ra.title.credits_applied')}
        preActionButtonJustify='flex-end'
        preActionButton={<>
        <LoadingButton loading={dataListLoading} onClick={()=>{setRefrshReserveCreditsApplied(!refreshReserveCreditsApplied)}}>
          <RefreshIcon/>
        </LoadingButton></>}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{translate('ra.field.currency')}</TableCell>
                <TableCell>{translate('ra.field.amount')}</TableCell>
                <TableCell>{translate('ra.field.amount_used')}</TableCell>
                <TableCell>{translate('ra.field.created_at')}</TableCell>
                <TableCell>{translate('ra.field.update_at')}</TableCell>
                <TableCell>{translate('ra.action.actions')}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {dataListLoading ? (
                <TableRow>
                  {[...Array(6)].map((_, i) => (
                    <TableCell key={i}>
                      <Skeleton variant='rectangular' width={'100%'} height={20} />
                    </TableCell>
                  ))}
                </TableRow>
              ) : (
                (paginationCreditData.rowsPerPage > 0
                  ? dataList?.slice(
                      paginationCreditData.page * paginationCreditData.rowsPerPage,
                      paginationCreditData.page * paginationCreditData.rowsPerPage +
                        paginationCreditData.rowsPerPage
                    )
                  : dataList
                )?.map((row, i) => {
                  return (
                    <Fragment key={i}>
                      <TableRow>
                        <TableCell>{row?.currency_relation.short_name}</TableCell>
                        <TableCell>{numberFormatterWithDecimalAndThousand(row?.amount_total)}</TableCell>
                        <TableCell>{numberFormatterWithDecimalAndThousand(row?.amount_used)}</TableCell>
                        <TableCell>{getDayWithTimeZone(row?.created_at, true)}</TableCell>
                        <TableCell>{getDayWithTimeZone(row?.updated_at, true)}</TableCell>
                        <HasPermission permission={PERMISSION_CREATE} resource={'payment-entity'}>
                          <TableCell>
                            <Tooltip placement='top' title='Ver detalle'>
                              <LoadingButton
                                size='small'
                                onClick={() => handleOpenDetailModal(row?.id)}
                                loading={loadingDetail}
                                startIcon={<Visibility fontSize='small' />}
                                color='primary'
                              ></LoadingButton>
                            </Tooltip>
                          </TableCell>
                        </HasPermission>
                      </TableRow>
                    </Fragment>
                  )
                })
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  colSpan={12}
                  count={dataList?.length}
                  rowsPerPage={paginationCreditData.rowsPerPage}
                  page={paginationCreditData.page}
                  onPageChange={(e, number) => onPageCreditChange(number)}
                  onRowsPerPageChange={(e) => onRowsPerPageCreditChange(e)}
                  labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                  }
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </ShowCard>

      <Dialog fullWidth maxWidth='md' open={openDetailModal} onClose={() => setOpenDetailModal(false)}>
        <DialogTitle>{`${translate('ra.title.credit_applied_detail')} ${originNumber}`}</DialogTitle>
        <DialogContent>
          {loadingDetail ? (
            <LinearProgress />
          ) : detailModalData.length ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{translate('ra.field.reserve')}</TableCell>
                    <TableCell>{translate('ra.field.amount_used')}</TableCell>
                    <TableCell>{translate('ra.field.description')}</TableCell>
                    <TableCell>{translate('ra.field.locator')}</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {detailModalData.map((elem, i) => (
                    <TableRow key={i}>
                      <TableCell>{elem?.item?.reservation?.number}</TableCell>
                      <TableCell>{numberFormatterWithDecimalAndThousand(elem?.amount_used)}</TableCell>
                      <TableCell>{getProductName({ ...elem?.item, ...elem?.item?.detail })}</TableCell>
                      <TableCell>{{ ...elem?.item, ...elem?.item?.detail }?.code}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>{translate('ra.message.no_details_available')}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setOpenDetailModal(false)}>
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}
